export function getQuarterCount(startDate: Date, duration: number): number {
    let total = 0;
    for (let i = 0; i < duration; i++) {
        total = total + getDaysMonth(new Date(startDate.getFullYear(), startDate.getMonth(), 1), 3);
    }
    return total;
}

export function getDaysMonth(startDate: Date, duration: number): number {
    let total = 0;
    for (let i = 0; i < duration; i++) {
        startDate = new Date(startDate.getFullYear(), startDate.getMonth() + i, 1);
        total = total + new Date(startDate.getFullYear(), (startDate.getMonth() + 1), 0).getDate();
    }
    return total;
}

export function countDays(endDate: Date, startDate: Date): number {
    return (new Date(endDate).getTime() - new Date(startDate).getTime())  / (1000 * 3600 * 24);
}
